function veda_fn_d56e66bbe60b40758b696df73dc4f34f () {
        
  if (window.veda_fn_d56e66bbe60b40758b696df73dc4f34fCleanup === undefined) {
    window.veda_fn_d56e66bbe60b40758b696df73dc4f34fCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_d56e66bbe60b40758b696df73dc4f34fCleanup.cleanup();

        try {
          const uniqueIds = ["id_8c8656b2-a882-4885-b48e-026cb9b78ec8","id_8f487d4d-556e-42c8-a103-b29c154f4751"];
          uniqueIds.forEach(uniqueId => {
            const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
            containers.forEach(container => {
              if (!container) {
                return;
              }
              veda.plugins.videoCover(container);
              
            });
          });
        } catch(error) {
          console.error(error);
        }
      }
veda_fn_d56e66bbe60b40758b696df73dc4f34f();